export default function About() {
  return (
    <>
      <div class="row_about">
        <div class="column_about">
          <div class="container_float">
            <h2>About :</h2>
            <br />
            <p className="about_content">
              I am a full stack developer at Société Générale in Hong Kong. I
              love to learn new things and make projects with my friends. I am
              interested by technologies, art and travels. I love movies,
              animation, design and games.
            </p>
          </div>
        </div>
        <div class="column_about">
          <div class="container_float">
            <h2>Experience :</h2>
            <br />
            <h2>Société Générale</h2>
            <p>VIE full stack developer, NOV 2022 - CURRENT</p>
            <h2>Orange Advertising</h2>
            <p>Trainee data analyst, FEB 2022 - JUL 2022</p>
            <h2>CEA</h2>
            <p>
              (Commissariat à l’Energie Atomique) trainee assistant engineer,
              SEP 2020 - FEB 2021
            </p>
            <h2>Steliau Technology</h2>
            <p>Test bench trainee, APR 2019 - JUL 2019</p>
          </div>
        </div>
      </div>
      <div class="footer_projects">
        <p>© Victor Perrault 2023. Currently in Hong Kong</p>
      </div>
    </>
  );
}
